import { namespaceClassName } from './namespace-classes';
import { Simulate } from 'react-dom/test-utils';
import { eventually, ensureExists } from '@wix/answers-lib';
export var createBaseDriverList = function (drivers) {
    var list = {
        count: function () { return drivers.length; },
        map: function (fn) { return drivers.map(fn); },
        filter: function (fn) { return createBaseDriverList(drivers.filter(fn)); },
        get: function (idx) { return drivers[idx]; },
        toArray: function () { return drivers; },
        getText: function () { return drivers.map(function (d) { return d.getText(); }); },
        getAttribute: function (name) { return drivers.map(function (d) { return d.getAttribute(name); }); },
        clickOn: function (idx) { return list.get(idx).click(); }
    };
    return list;
};
export var simulateClick = function (elem) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('click', true, false);
    // tslint:disable:max-line-length
    // setting button 0 is now needed in React 16+ as it's not set by react anymore
    // 15 - https://github.com/facebook/react/blob/v15.6.1/src/renderers/dom/client/syntheticEvents/SyntheticMouseEvent.js#L45
    // 16 - https://github.com/facebook/react/blob/master/packages/react-dom/src/events/SyntheticMouseEvent.js#L33
    event.button = 0;
    elem.dispatchEvent(event);
};
export var simulateBlur = function (elem) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('blur', true, false);
    elem.dispatchEvent(event);
};
export var enterValue = function (elem, value) {
    elem.value = value;
    Simulate.change(elem);
};
export var pressKey = function (elem, keyCode) {
    var event = new Event('keydown', { bubbles: true });
    event.keyCode = keyCode;
    elem.dispatchEvent(event);
};
export var simulateMouseOver = function (elem) {
    Simulate.mouseOver(elem);
};
export var simulateMouseOut = function (elem) {
    Simulate.mouseOut(elem);
};
export var isBaseDriver = function (elemOrDriver) {
    return !!elemOrDriver.findAll;
};
export var getBaseReactDriver = function (elemOrDriver) {
    var elem = isBaseDriver(elemOrDriver) ? elemOrDriver.elem : elemOrDriver;
    var isChildVisible = function (selector) { return !!elem.querySelector(selector); };
    var baseDriver = {
        getText: function () { return elem.textContent || ''; },
        elem: elem,
        find: function (selector) {
            var child = ensureExists(elem.querySelector(selector), "Element with selector " + selector + " does not exist");
            return getBaseReactDriver(child);
        },
        getAttribute: function (name) { return elem.getAttribute(name) || ''; },
        findAll: function (selector) {
            var bds = Array.prototype.slice.call(elem.querySelectorAll(selector)).map(getBaseReactDriver);
            return createBaseDriverList(bds);
        },
        isChildVisible: isChildVisible,
        waitUntilVisible: function (selector) {
            return eventually(function () { return isChildVisible(selector); });
        },
        click: function () {
            simulateClick(elem);
        },
        enterValue: function (value) {
            enterValue(elem, value);
        },
        pressKey: function (keyCode) {
            pressKey(elem, keyCode);
        },
        getDataAttr: function (name) { return elem.getAttribute("data-" + name) || ''; },
        getInnerHtml: function () { return elem.innerHTML; },
        hasClass: function (name) { return elem.classList.contains(name); },
        mouseOver: function () {
            simulateMouseOver(elem);
        },
        mouseOut: function () {
            simulateMouseOut(elem);
        },
        mouseEnter: function () {
            Simulate.mouseEnter(elem);
        },
        mouseDown: function () {
            Simulate.mouseDown(elem);
        }
    };
    return baseDriver;
};
export var getLegacyBaseDriverFromWrapper = function (wrapper, selector, name) {
    var namespacedSelector = "." + namespaceClassName + selector;
    var elements = wrapper.querySelectorAll(namespacedSelector);
    if (elements.length === 0) {
        throw new Error("Unable to locate " + name + " component for given wrapper");
    }
    if (elements.length > 1) {
        throw new Error("There is more than one [" + name + "] for given wrapper. Please be more specific");
    }
    return getBaseReactDriver(elements[0]);
};
//# sourceMappingURL=base-driver.js.map